import { appPlatform } from "@/lib/platform";

// Yalola 1.5.2 payment architecture (decided, do not change without approval):
//   Web      → Stripe
//   Android  → Google Play Billing (RevenueCat)
//   iOS      → Apple IAP / StoreKit (RevenueCat)
//   Admin    → free grant (server side)
// Stripe is NEVER a fallback on the native apps: when the store of the device is not
// configured yet (Admin › Intégrations), the purchase is simply unavailable ("Bientôt disponible").
export const STORE_NAME = { ios: "App Store", android: "Google Play" };

export const purchaseChannel = (payments) => {
  const platform = appPlatform();
  if (platform === "web") return { channel: "stripe", platform, store: null };
  const enabled = platform === "ios" ? !!payments?.iap?.apple_enabled : !!payments?.iap?.google_enabled;
  return { channel: enabled ? "store" : "unavailable", platform, store: STORE_NAME[platform] };
};

// Donations (Soutiens) are a separate case: Stripe everywhere, but OFF on iOS until the
// admin switches `ios_donations_enabled` on (Apple 3.2.1 vii validation).
export const donationsAvailable = (payments, features) => {
  if (features?.donations === false) return false;
  if (appPlatform() === "ios") return !!payments?.ios_donations_enabled;
  return true;
};

export const PROVIDER_LABEL = {
  stripe: "Stripe", apple: "App Store", google: "Google Play", admin: "Yalola (admin)",
  wallet: "Crédits pub", offline: "Hors ligne", comp: "Offert", points: "Points de parrainage",
};
export const providerLabel = (p) => PROVIDER_LABEL[p] || p || "";

export const fmtMoney = (n, cur = "EUR", lang = "fr") => {
  const v = Math.round((Number(n) || 0) * 100) / 100;
  try {
    return new Intl.NumberFormat(lang === "en" ? "en-GB" : lang === "es" ? "es-ES" : lang === "pt" ? "pt-PT" : "fr-FR",
      { style: "currency", currency: (cur || "EUR").toUpperCase(), minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v);
  } catch {
    return `${v.toFixed(2)} ${cur}`;
  }
};
